'use strict';
/**
 * @ngdoc function
 * @name exhibitorPortalApp.controller:SurveyPreviewModalCtrl
 * @description
 * # SurveyPreviewModalCtrl
 * Controller for the survey preview modal
 */
(function (angular, window, undefined) {
  var SurveyPreviewModalCtrl = function ($scope, $modalInstance,  templates, inputs) {
    'ngInject'
    var self = this;

    self.templates = templates;

    self.previewData = inputs.previewData;
    self.title = inputs.title;
    self.currentQuestionIndex = 0;
    self.answers = {};
    self.validationError = null;
    self.importantWarningShown = {};
    self.navigationHistory = [self.currentQuestionIndex];

    self.isQuestionAnswered = function(question) {
      if (question.SurveyQuestionTypeCode === 'SGL' || question.SurveyQuestionTypeCode === 'OPN') {
        return self.answers[question.Id];
      } else if (question.SurveyQuestionTypeCode === 'MLT') {
        return Object.keys(self.answers).some(function(key) {
          return key.startsWith('q' + question.Id + '_a') && self.answers[key];
        });
      }
      return false;
    };

    self.validateCurrentQuestion = function() {
      var currentQuestion = self.previewData.questions[self.currentQuestionIndex];
      if (currentQuestion.Priority === 'REQUIRED' && !self.isQuestionAnswered(currentQuestion)) {
        self.validationError = 'This question is required. Please provide an answer before continuing.';
        return false;
      }
      if (currentQuestion.Priority === 'IMPORTANT' && !self.isQuestionAnswered(currentQuestion)) {
        if (!self.importantWarningShown[currentQuestion.Id]) {
          self.validationError = 'This question is important. Click again to skip or provide an answer.';
          self.importantWarningShown[currentQuestion.Id] = true;
          return false;
        }
      }
      self.validationError = null;
      return true;
    };

    self.getNextQuestionIndex = function() {
      var currentQuestion = self.previewData.questions[self.currentQuestionIndex];
      if (currentQuestion.SurveyQuestionTypeCode === 'SGL' && self.answers[currentQuestion.Id]) {
        var selectedAnswerId = self.answers[currentQuestion.Id];
        var selectedAnswer = currentQuestion.SurveyAnswers.find(function(answer) {
          return answer.Id === selectedAnswerId;
        });
        if (selectedAnswer && selectedAnswer.BranchAction === 'OVERRIDE' && selectedAnswer.NextQuestionId) {
          var nextQuestionIndex = self.previewData.questions.findIndex(function(q) {
            return q.Id === selectedAnswer.NextQuestionId;
          });
          return nextQuestionIndex !== -1 ? nextQuestionIndex : self.currentQuestionIndex + 1;
        }
        if (selectedAnswer && selectedAnswer.BranchAction === 'ENDSURVEY') {
          return 'END';
        }
      }
      return self.currentQuestionIndex + 1;
    };

    self.prevQuestion = function() {
      self.validationError = null;
      self.importantWarningShown = {};
      if (self.navigationHistory.length > 1) {
        self.navigationHistory.pop();
        self.currentQuestionIndex = self.navigationHistory[self.navigationHistory.length - 1];
      }
    };

    self.close = function() {
      $modalInstance.close();
    };

    self.dismiss = $modalInstance.dismiss;

    self.handleDoneOrNext = function() {
      if (!self.validateCurrentQuestion()) return;

      var nextIndex = self.getNextQuestionIndex();
      if (nextIndex === 'END' || self.currentQuestionIndex === self.previewData.questions.length - 1) {
        self.dismiss();
      } else if (nextIndex < self.previewData.questions.length) {
        self.currentQuestionIndex = nextIndex;
        self.navigationHistory.push(nextIndex);
      }
    };
  };

  angular.module('exhibitorPortalApp')
    .controller('SurveyPreviewModalCtrl', SurveyPreviewModalCtrl);
})(angular, window);
